import { profileStepDataStore } from "../../redux/ProfileReducer/ProfileReducer";

const getCompanyById = (companyId: number) => {
  const { companies } = profileStepDataStore.getState();
  if (companyId === -1) return null;
  return companies.find((x) => x.id === companyId)?.name;
};
export default getCompanyById;
